/**
 * Lazy load modules
 *
 * @returns {Object} - lazy load methods and properties
 */
const lazyLoad = () => {
    /**
     * lazy loads the images
     */
    const load = () => {
        const images = Array.from(document.querySelectorAll('.lazy'));
        images.forEach(item => {
            if (!item.dataset.src) return;

            const img = new Image();
            /**
             * image load callback function
             */
            img.onload = function () {
                item.setAttribute('src', item.dataset.src);
                /*
                 * temporarily commenting below code.
                 * sometimes image url is shown as undefined and this will help in debugging it
                 * it doesn't happen all the time hence will remove it after catching the root cause
                 */
                // item.classList.remove('lazy');
                // item.removeAttribute('data-src');
            };

            /**
             * image error callback function
             */
            img.onerror = function () {
                item.classList.remove('lazy');
                item.removeAttribute('data-src');
            };

            img.src = item.dataset.src;
        });
    };

    return {
        load
    };
};

export default lazyLoad();
